export const LayoutEnum = Object.freeze({
    CARD: "CARD",
    LIST: "LIST",
});
